import { UserRole } from 'shared/types/userRole';

export function isViewer(role: UserRole): boolean {
  return role === UserRole.viewer;
}
